import React from 'react'
import { Spinner as ShadcnSpinner } from 'components/ui/spinner'

export interface Props {
	className?: string
	width?: string
	containerHeight?: string
}

const Spinner = ({ className = '', width = '50', containerHeight }: Props) => {
	return <ShadcnSpinner className={className} width={width} containerHeight={containerHeight} />
}

export default Spinner
